import usePlayers from "@/hooks/usePlayers"
import useUser from "@/hooks/useUser"

const PlayerSelect = ({
  hidePlayerId,
  value,
  onChange,
}: {
  hidePlayerId?: string
  value?: string
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
}) => {
  const { players, isLoading } = usePlayers()
  const { user } = useUser()
  const myPlayerId = user?.player_id

  const filteredPlayers = players.filter((player) => player.id !== hidePlayerId)

  // Pin "Me" player first
  const sortedPlayers = myPlayerId
    ? [
        ...filteredPlayers.filter((p) => p.id === myPlayerId),
        ...filteredPlayers.filter((p) => p.id !== myPlayerId),
      ]
    : filteredPlayers

  return (
    <div>
      <label
        htmlFor="player"
        className="block text-sm leading-6 font-medium text-gray-900"
      >
        Select new player
      </label>
      <div className="relative">
        <select
          value={value}
          onChange={onChange}
          disabled={isLoading}
          id="player"
          className="focus:ring-chessdrop-600 mt-1 block w-full rounded-lg border-0 py-2 text-gray-900 shadow-xs ring-1 ring-gray-300 ring-inset placeholder:text-gray-400 focus:ring-2 focus:ring-inset"
        >
          <option value="" />
          {sortedPlayers.map((player) => (
            <option key={player.id} value={player.id}>
              {player.name}{player.id === myPlayerId ? " (Me)" : ""}
            </option>
          ))}
        </select>
        {isLoading && (
          <div className="absolute top-1/2 right-10 -translate-y-1/2 transform">
            <div
              className="h-3.5 w-3.5 animate-spin rounded-full border-2 border-gray-400"
              style={{ borderRightColor: "transparent" }}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default PlayerSelect
